import React, { useEffect } from "react";
import AccountService from "./Services/accountService";
import { GlobalLoaderProvider } from "./LayoutComponents/GlobalLoader";

import { ToastProvider } from "./LayoutComponents/ToastContext";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Dashboard from "./Pages/Content/Dashboard";
import Clients from "./Pages/Content/Clients";
import UserServices from "./Pages/Content/UserServices";
import RootLayout from "./LayoutComponents/RootLayout.jsx";
import LoginPage from "./Pages/LoginPage.jsx";
import ErrorPage from "./LayoutComponents/ErrorPage.jsx";
import MediathequePage from "./Pages/Content/MediathequePage.jsx";
import { AuthProvider } from "./AuthProvider/AuthProvider.js";
import PrivateRoute from "./LayoutComponents/PrivateRoute.jsx";
import { ClientsProvider } from "./Context/ClientsContext.js";
import Horses from "./Pages/Content/Horses.jsx";
import { HorsesProvider } from "./Context/HorsesContext.js";
import { UserServicesProvider } from "./Context/UserServiceContext.js";
import MyAccount from "./Pages/Content/MyAccount.jsx";
import ChangeEmailConfirmationPage from "./Pages/ChangeEmailConfirmationPage.jsx";
import CancelChangeEmailPage from "./Pages/CancelChangeEmailPage.jsx";
import ResetPassword from "./Pages/ResetPasswordPage.jsx";
import RequestResetPassword from "./Pages/RequestResetPasswordPage.jsx";
import { ModalProvider } from "./Context/ModalContext.js";
import { PrivilegeProvider } from "./Context/PrivilegeContext.js";
import { EditLockProvider } from "./Components/FileUploaderModal/EditLockContext.js";
import RegisterPage from "./Pages/RegisterPage.jsx";
import AccountCreatedPage from "./Pages/AccountCreatedPage.jsx";
import ConfirmAccountPage from "./Pages/ConfirmAccountPage.jsx";
import CalendarPage from "./Pages/Content/CalendarPage.jsx";
import ErrorBoundary from "./Components/ErrorBoundary.js";
import UpgradeCheckoutSuccess from "./Pages/UpgradeCheckoutSuccess.jsx";
import { ParameterProvider } from "./Context/ParameterContext.js";
const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/signup",
    element: <RegisterPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/requestresetpassword",
    element: <RequestResetPassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/accountcreated",
    element: <AccountCreatedPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/resetpassword",
    element: <ResetPassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/confirmemailchange",
    element: <ChangeEmailConfirmationPage />,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/confirmaccount",
    element: <ConfirmAccountPage />,
    //errorElement: <ErrorPage />,
  },

  {
    path: "/cancelchangeemail",
    element: <CancelChangeEmailPage />,
    //errorElement: <ErrorPage />,
  },
  {
    path: "/upgradecheckoutsuccess",
    element: <UpgradeCheckoutSuccess />,
  },
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: (
          <PrivateRoute>
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          </PrivateRoute>
        ),
      },
      {
        path: "/dashboard",
        element: (
          <PrivateRoute>
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          </PrivateRoute>
        ),
      },
      {
        path: "/calendar",
        element: (
          <PrivateRoute>
            <ErrorBoundary>
              <CalendarPage />
            </ErrorBoundary>
          </PrivateRoute>
        ),
      },
      {
        path: "/clients",
        element: (
          <PrivateRoute>
            <ErrorBoundary>
              <ClientsProvider>
                <Clients />
              </ClientsProvider>
            </ErrorBoundary>
          </PrivateRoute>
        ),
      },
      {
        path: "/horses",
        element: (
          <PrivateRoute>
            <ErrorBoundary>
              <HorsesProvider>
                <Horses />
              </HorsesProvider>
            </ErrorBoundary>
          </PrivateRoute>
        ),
      },
      {
        path: "/userservices",
        element: (
          <PrivateRoute>
            <ErrorBoundary>
              <UserServicesProvider>
                <UserServices />
              </UserServicesProvider>
            </ErrorBoundary>
          </PrivateRoute>
        ),
      },
      {
        path: "/mediatheque",
        element: (
          <PrivateRoute>
            <ErrorBoundary>
              <MediathequePage />
            </ErrorBoundary>
          </PrivateRoute>
        ),
      },
      {
        path: "/myaccount",
        element: (
          <PrivateRoute>
            <ErrorBoundary>
              <MyAccount />
            </ErrorBoundary>
          </PrivateRoute>
        ),
      },
    ],
  },
]);

const App = () => {
  useEffect(() => {
    AccountService.IsLoggedIn();
  }, []);

  return (
    <ParameterProvider>
      <AuthProvider>
        <PrivilegeProvider>
          <GlobalLoaderProvider>
            <ToastProvider>
              <EditLockProvider>
                <ModalProvider>
                  <RouterProvider router={router} />
                </ModalProvider>
              </EditLockProvider>
            </ToastProvider>
          </GlobalLoaderProvider>
        </PrivilegeProvider>
      </AuthProvider>
    </ParameterProvider>
  );
};

export default App;
